import { useState } from 'react';
import { Button, Checkbox, Space, Tooltip } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import ApiService from '../../core/service/api-service';

// Dicom Zip indirme seçenekleri. DICOMDIR varsayılan açık: seçenek gelmeden önceki davranış buydu.
// Görüntüleyici seçilirse zip, paylaşım linkindeki "Görüntüleyici Dahil Et" ile aynı akıştan üretilir.
// Sıkıştırma açıkken görüntüler kayıpsız sıkıştırılmış (JPEG Lossless) iner; kapalıyken sıkıştırmasız.
export default function DicomZipDownloadModal({ studies = [], onClose }) {
    const { t } = useTranslation();
    const [includeDicomDir, setIncludeDicomDir] = useState(true);
    const [includeViewer, setIncludeViewer] = useState(false);
    const [compress, setCompress] = useState(true);

    const download = () => {
        ApiService.Dicom.DownloadDicomZip(studies, { includeDicomDir, includeViewer, compress });
        onClose && onClose();
    };

    return (
        <div style={{ padding: '16px 0' }}>
            <Space direction="vertical">
                <Checkbox
                    checked={includeDicomDir}
                    onChange={(e) => setIncludeDicomDir(e.target.checked)}
                >
                    {t('Include DICOMDIR')}
                </Checkbox>
                <Checkbox
                    checked={includeViewer}
                    onChange={(e) => setIncludeViewer(e.target.checked)}
                >
                    {t('Include Viewer')}
                </Checkbox>
                <Tooltip title={t('Images are compressed losslessly: smaller download, same image quality. Turn off for uncompressed DICOM.')}>
                    <Checkbox
                        checked={compress}
                        onChange={(e) => setCompress(e.target.checked)}
                    >
                        {t('Compress (lossless)')}
                    </Checkbox>
                </Tooltip>
            </Space>

            <div style={{ marginTop: 16, textAlign: 'right' }}>
                <Space>
                    <Button onClick={onClose}>{t('Cancel')}</Button>
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        disabled={studies.length === 0}
                        onClick={download}
                    >
                        {t('Download')}
                    </Button>
                </Space>
            </div>
        </div>
    );
}
